var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasksDeprecated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-tasks",
    viewBox: "0 0 18 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 3h-3.75c0-1.655-1.345-3-3-3s-3 1.345-3 3h-3.75c-1.242 0-2.25 1.008-2.25 2.25v16.5c0 1.242 1.008 2.25 2.25 2.25h13.5c1.242 0 2.25-1.008 2.25-2.25v-16.5c0-1.242-1.008-2.25-2.25-2.25zM9 1.875c0.623 0 1.125 0.502 1.125 1.125s-0.502 1.125-1.125 1.125c-0.623 0-1.125-0.502-1.125-1.125s0.502-1.125 1.125-1.125zM3.075 9.816l0.595-0.591c0.098-0.098 0.258-0.098 0.356 0l0.966 0.975 2.231-2.212c0.098-0.098 0.258-0.098 0.356 0l0.591 0.595c0.098 0.098 0.098 0.258 0 0.356l-3.009 2.981c-0.098 0.098-0.258 0.098-0.356 0l-1.73-1.748c-0.098-0.098-0.098-0.258 0-0.356zM4.5 18.375c-0.623 0-1.125-0.502-1.125-1.125s0.502-1.125 1.125-1.125c0.623 0 1.125 0.502 1.125 1.125s-0.502 1.125-1.125 1.125zM15 17.625c0 0.206-0.169 0.375-0.375 0.375h-6.75c-0.206 0-0.375-0.169-0.375-0.375v-0.75c0-0.206 0.169-0.375 0.375-0.375h6.75c0.206 0 0.375 0.169 0.375 0.375v0.75zM15 11.625c0 0.206-0.202 0.375-0.45 0.375h-7.327l1.514-1.5h5.813c0.248 0 0.45 0.169 0.45 0.375v0.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksDeprecated);
export default __webpack_public_path__ + "static/media/tasks-deprecated.500c5408a2060bcc68cfaae886e9dc6c.svg";
export { ForwardRef as ReactComponent };